import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S4-WB1
// (PRA-791). Now served by `api-core-node` at
// `POST /api/public/engagement-letters::save-signature`. The legacy
// `saveEngagementLetterSignatureSecondGen` callable continues to exist in
// `cloudFunctions/` until S9-WB2.
//
// Idempotency is enforced server-side by a **durable business-state guard**
// (the engagement-letter doc's `letterSigned` event is appended inside a
// Firestore transaction; a duplicate save reads the existing event and
// returns the original outcome). The client does not need to send an
// `Idempotency-Key` header — the doc itself is the canonical record.
// See `services/api-core-node/src/routes/plugins/engagementLetters.ts` for
// the rationale (the wire payload's `letterUrl` / `timestamp` change on each
// retry, so a body-fingerprint-based API-layer key would reject retries).
export const saveEngagementLetterSignatureRoute = {
  transport: 'api',
  method: 'POST',
  path: '/public/engagement-letters:save-signature',
} as const satisfies BackendRouteDefinition;
